<template>
    <div id="settings">
        <div><c-input v-model="devName" :title="$t('text.deviceName')" labelWidth="150px" :doubleDot="true"></c-input></div>
        <div><c-input v-model="toastTime" :title="$t('text.toastTimeLabel')" labelWidth="150px" :doubleDot="true" type="select" :options="toastDuration"></c-input></div>
        <div><c-input v-model="showFW" :title="$t('text.displayFocusWatch')" labelWidth="150px" :doubleDot="true" type="checkbox"></c-input></div>
        <div><c-input v-model="locale" :title="$t('text.language')" labelWidth="150px" :doubleDot="true" type="select" :options="getLanguages"></c-input></div>
        <!-- <div><select>
            <option v-for="(l, i) in getLanguages" :key="i">{{l}}</option>    
        </select></div> -->
        <div class="button-row">
            <c-button :label="$t('text.abort')" type="link-button" @click="abort"></c-button>
            <c-button :label="$t('text.save')" @click="save"></c-button>
        </div>
    </div>
</template>

<script>

import CInput from './CInput';
import CButton from './CButton';

import { mapGetters, mapMutations } from 'vuex';

import setMut from '../store/mutations/settings';

export default {
    name: "Settings",
    data: function(){
        return {
            devName: null, 
            toastTime: 0,
            showFW: null,
            locale: null,
            toastDuration: [{
                value: 0,
                label: this.$i18n.t('text.letIt'),
            },{
                value: 10,
                label: '0:10',
            },{
                value: 20,
                label: '0:20',
            },{
                value: 30,
                label: '0:30',
            },{
                value: 60,
                label: '01:00',
            }],
        }
    },
    methods:{
        ...mapMutations([
            setMut.SETDEVICENAME,
            setMut.SETTOASTTIME,
            setMut.SETFOCUSWATCH,
            setMut.SETLANG,
        ]),
        abort(){
            this.$router.go(-1);
        },
        save(){
            if(!!this.devName){
                this.SETDEVICENAME(this.devName);
            }

            if(this.toastTime === '')
                this.toastTime = 0;
            this.SETTOASTTIME(this.toastTime);

            this.SETFOCUSWATCH(this.showFW);

            this.SETLANG({t: this, locale: this.locale});
            this.$router.go(-1);
        }
    },
    computed:{
        ...mapGetters(['DeviceName', 'ToastTime', 'ShowFocusWatch', 'Locale']),
        getLanguages(){
            return this.$i18n.availableLocales.map( l => {
                return {value: l, label: this.$i18n.t(`text.lang.${l}`)}
            });
        }
    },
    components: {
        CInput,
        CButton,
    },
    mounted(){
        this.devName = this.DeviceName;
        this.toastTime = this.ToastTime/1000;
        this.showFW = this.ShowFocusWatch;
        this.locale = this.Locale;
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    #settings {
        background-color:$form-bg-color;
        padding:10px;

        > div {
            padding-bottom: 10px;
        }

        .button-row {
            @extend %f-row;
            justify-content: flex-end;
        }
    }

</style>